import {DxAppError} from "./dx-app-error";


/**
 * Класс ошибки выполнения `http`-запроса.
 * Создан для свертывания зоопарка респонсов с ошибками в унифицированную структуру.
 * @publicApi
 */
export class HttpError extends DxAppError {
  /**
   * Статус-код ошибки выполнения `http`-запроса.
   * @name _status
   * @type {number}
   */
  private _status: number;

  /**
   * Тест статуса ошибки выполнения `http`-запроса.
   * @name _statusText
   * @type {string}
   */
  private _statusText: string;

  /**
   * Создает инстанс ошибки выполнения `http`-запроса.
   * @constructor
   */
  constructor() {
    super();
    this._name = 'DxHttpError'
  }

  /**
   * Возвращает статус-код ошибки выполнения `http`-запроса.
   * @public
   * @return {number} - статус-код ошибки выполнения `http`-запроса.
   */
  get status(): number {
    return this._status;
  }

  /**
   * Устанавливает статус-код ошибки выполнения `http`-запроса.
   * @public
   * @param {number} value - статус-код ошибки выполнения `http`-запроса.
   */
  set status(value: number) {
    this._status = value;
  }

  /**
   * Возвращает тест статуса ошибки выполнения `http`-запроса.
   * @public
   * @return {string} - тест статуса ошибки выполнения `http`-запроса.
   */
  get statusText(): string {
    return this._statusText;
  }

  /**
   * Устанавливает тест статуса ошибки выполнения `http`-запроса.
   * @public
   * @param {string} value - тест статуса ошибки выполнения `http`-запроса.
   */
  set statusText(value: string) {
    this._statusText = value;
  }
}
